<template>
  <base-page-layout title="SMS de Trade">
    <new-filters-menu class="mb-4" :filters="['industrias']" />

    <v-container fluid class="px-0 pt-5" grid-list-lg>
      <v-layout>
        <v-flex v-for="(card, index) in cards" :key="index" xs4>
          <cbm-card :number-text="card.value" :title="card.text" :boolean-loader="card.loading" unset-percentage-colors simple-card />
        </v-flex>
      </v-layout>
    </v-container>

    <campaigns-table mode="sms" logsTag="CAMPAIGNS" :industry="true" :itemsFilter="filterList">
      <template v-slot:title> Campanhas de trade </template>
    </campaigns-table>
  </base-page-layout>
</template>

<script>
import BasePageLayout from '@/components/BasePageLayout.vue'
import CbmCard from '@/components/CbmCard.vue'
import CampaignsTable from '@/modules/campanhas/views/components/index/CampaignsTable.vue'
import { mapGetters } from 'vuex'
import { getStatusLabel, localeString } from '@/config/helpers.js'
import { QUERY_GET_CAMPAIGNS_COUNTS_PER_STATUS } from '@/modules/campanhas/campanhas-sms/graphql'

export default {
  components: {
    BasePageLayout,
    CbmCard,
    CampaignsTable,
    NewFiltersMenu: () => import('@/components/filters-menu/NewFiltersMenu.vue'),
  },
  data: () => ({
    loading: false,
    activeCampaignCount: 0,
    scheduledCampaignsCount: 0,
    finishedCampaignsCount: 0,
    filterList: [
      { label: getStatusLabel('INACTIVE').text, value: 'INACTIVE', color: getStatusLabel('INACTIVE').color, active: true },
      { label: getStatusLabel('SCHEDULED').text, value: 'SCHEDULED', color: getStatusLabel('SCHEDULED').color, active: true },
      { label: getStatusLabel('ACTIVE').text, value: 'ACTIVE', color: getStatusLabel('ACTIVE').color, active: true },
      { label: getStatusLabel('FINISHED').text, value: 'FINISHED', color: getStatusLabel('FINISHED').color, active: true },
      { label: getStatusLabel('EXPIRED').text, value: 'EXPIRED', color: getStatusLabel('EXPIRED').color, active: true },
    ],
  }),
  computed: {
    ...mapGetters(['smsCountsChanged', 'getSelectedIndustriesIds']),

    cards() {
      return [
        {
          value: localeString(this.activeCampaignCount || 0),
          text: 'Campanhas ativas',
          isInteger: true,
          loading: this.loading,
        },
        {
          value: localeString(this.scheduledCampaignsCount || 0),
          text: 'Campanhas agendadas',
          isInteger: true,
          loading: this.loading,
        },
        {
          value: localeString(this.finishedCampaignsCount || 0),
          text: 'Campanhas realizadas',
          isInteger: true,
          loading: this.loading,
        },
      ]
    },
  },
  watch: {
    smsCountsChanged(value) {
      if (value) {
        this.getSmsCampaignsCounts()
      }
    },
  },
  mounted() {
    this.getSmsCampaignsCounts()
    this.$nextTick(() => {
      this.$bus.$on('filter', () => {
        this.getSmsCampaignsCounts()
      })
    })
  },
  beforeDestroy() {
    this.$bus.$off('filter')
  },
  methods: {
    async getSmsCampaignsCounts() {
      try {
        this.loading = true
        const result = await this.$apollo.query({
          query: QUERY_GET_CAMPAIGNS_COUNTS_PER_STATUS,
          fetchPolicy: 'no-cache',
          variables: {
            isIndustry: true,
            industryIds: this.getSelectedIndustriesIds,
          },
        })
        this.$store.commit('smsCountsChanged', false)
        this.scheduledCampaignsCount = result.data.campaignsCountsPerStatus.SCHEDULED
        this.activeCampaignCount = result.data.campaignsCountsPerStatus.ACTIVE
        this.finishedCampaignsCount = result.data.campaignsCountsPerStatus.FINISHED
      } catch (e) {
        this.$snackbar({ message: 'Ocorreu um erro ao calcular as campanhas agendadas.' })
        console.log(e)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
<style lang="scss" scoped></style>
